// extracted by mini-css-extract-plugin
module.exports = {"answersHeader":"DqP6eruKTuCLFkEGK3t4","flexed":"pLoyom60m38Z9xZ79ym5","row":"dgLbJu3sWTA66eyu9UvA","answer":"EGzrep07BszxddbobVPw","answerInput":"cetXoHtdPkwNkrknyqOD"};